'use client';

import clsx from 'clsx';
import { MagnifyingGlassIcon, MapPinIcon } from '@heroicons/react/24/outline';
import InputSearchBar from './_components/InputSearchBar';
import { SearchBarSubmitButton } from './_components/SearchBarSubmitButton';
import SearchBar from './SearchBarBase';
import { SearchBarServiceLocationProps } from './types';

type SearchBarServiceLocationPlaceholderProps = Pick<
  SearchBarServiceLocationProps,
  'size' | 'showShadow' | 'servicePlaceholder' | 'locationPlaceholder' | 'submitLabel' | 'submitButtonColor'
>;

const noop = () => {};

// Static stand-in for SearchBarServiceLocation, used as Suspense fallback: useSearchParams makes the real
// search bar client-only on prerendered pages, so this reserves the same space to avoid a layout shift.
export const SearchBarServiceLocationPlaceholder: React.FC<SearchBarServiceLocationPlaceholderProps> = ({
  size = 'sm',
  showShadow = false,
  servicePlaceholder = 'Cerca una prestazione',
  locationPlaceholder = 'Dove? Indirizzo o città',
  submitLabel = 'Cerca',
  submitButtonColor = 'secondary',
}) => (
  <div className="w-full">
    <SearchBar size={size} showShadow={showShadow}>
      <div className="group relative h-full w-full">
        <InputSearchBar position="left" size={size} icon={MagnifyingGlassIcon} placeholder={servicePlaceholder} value="" setValue={noop} />
      </div>

      <div className={clsx('hidden h-full w-px bg-neutral-active lg:block', size === 'sm' && 'py-2')}>
        <div className="h-full w-px bg-neutral-inactive" />
      </div>

      <div className="group relative h-full w-full">
        <InputSearchBar position="right" size={size} icon={MapPinIcon} placeholder={locationPlaceholder} value="" setValue={noop} />
      </div>

      <SearchBarSubmitButton size={size} submitLabel={submitLabel} submitButtonColor={submitButtonColor} />
    </SearchBar>
  </div>
);
